import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import { SummaryInformationCard } from 'app/components/summary-information-card';
import { SummaryInformationRow } from 'app/components/summary-information-row';
import { i18n } from 'app/i18n';
import {
    selectSelectedServiceLocationOrThrow,
    selectSelectedUserDetailsOrThrow,
} from 'app/pages/order/redux/order-selector';
import { OrderInformationUtils } from 'app/pages/order/utils/order-information-utils';

const PaymentInformationCard: FunctionComponent = () => {
    const userDetails = useSelector(selectSelectedUserDetailsOrThrow);
    const serviceLocation = useSelector(selectSelectedServiceLocationOrThrow);

    return (
        <SummaryInformationCard
            title={i18n.page.summary.paymentInformation.title}
            content={
                <div>
                    <SummaryInformationRow
                        label={i18n.page.summary.paymentInformation.customer}
                        value={OrderInformationUtils.getFullName(userDetails)}
                        isValueSensitive={true}
                    />
                    <SummaryInformationRow
                        label={i18n.page.summary.paymentInformation.address}
                        value={OrderInformationUtils.getShortAddress(serviceLocation)}
                        isValueSensitive={true}
                    />
                    <SummaryInformationRow
                        label={i18n.page.summary.paymentInformation.paymentMethod.label}
                        value={i18n.page.summary.paymentInformation.paymentMethod.defaultMethod}
                        note={{ label: i18n.page.summary.paymentInformation.paymentMethod.description }}
                    />
                </div>
            }
        />
    );
};

export { PaymentInformationCard };
